var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","display":"flex","align-items":"center","justify-content":"center","height":"400px"},attrs:{"id":"abc"}},[_c('div',{staticClass:"loader"})])
}]

export { render, staticRenderFns }